import { store } from 'v3/data/store';
import { productsSlice } from 'v3/data/store/product';
import { ISku } from 'v3/services/interfaces/response';
import {
  IGroupProduct,
  IGroupProducts,
  IProduct,
  IProducts,
  ISkusProducts,
  IUpdateProduct,
  IUpdateProductLmi,
  IUpdateProductMaxPercentage,
} from './types';

export const setProducts = (products: IProducts) => {
  store.dispatch(productsSlice.actions.setProducts(products));
};

export const setGroupProducts = (products: IGroupProducts) => {
  store.dispatch(productsSlice.actions.setGroupProducts(products));
};

export const setProductSelected = (product: IProduct) => {
  store.dispatch(productsSlice.actions.setProductSelected(product));
};

export const setProductsSkus = (skus: ISkusProducts) => {
  store.dispatch(productsSlice.actions.setProductsSkus(skus));
};

export const setSkuSelected = (sku: ISku) => {
  store.dispatch(productsSlice.actions.setSkuSelected(sku));
};

export const setGroupProductSelected = (product: IGroupProduct) => {
  store.dispatch(productsSlice.actions.setGroupProductSelected(product));
};

export const setPage = (page: number) => {
  store.dispatch(productsSlice.actions.setPage(page));
};

export const setLimit = (limit: number) => {
  store.dispatch(productsSlice.actions.setLimit(limit));
};

export const setModelNameFilter = (model: string) => {
  store.dispatch(productsSlice.actions.setModelNameFilter(model));
};

export const setProductAvailability = (available: boolean | null) => {
  store.dispatch(productsSlice.actions.setProductAvailability(available));
};

export const clearModelFilter = () => {
  store.dispatch(productsSlice.actions.setModelNameFilter(''));
};

export const clearAvailableFilter = () => {
  store.dispatch(productsSlice.actions.setProductAvailability(null));
};

export const setProductValues = (product: IUpdateProduct) => {
  store.dispatch(productsSlice.actions.setProductValues(product));
};

export const setProductLmi = (product: IUpdateProductLmi) => {
  store.dispatch(productsSlice.actions.setProductLmi(product));
};

export const setProductMaxPercentage = (product: IUpdateProductMaxPercentage) => {
  store.dispatch(productsSlice.actions.setProductMaxPercentage(product));
};

export const groupProductsHotUpdate = (product: IGroupProduct) => {
  store.dispatch(productsSlice.actions.groupProductsHotUpdate(product));
};
